import React, { useState } from 'react'
import PageTitle from '../Utilities/PageTitle'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { Link } from 'react-router-dom';
export default function MediaCenter(props) {
    // subscribe form

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const customStyles = {
        content: {
            top: '0',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            // transform: 'translate(-50%, -50%)',
        },
    };
    //  all values

    const [email, setEmail] = useState();


    const [submitMsg, setSubmitMsg] = useState('');
    const [message, setMessage] = useState('');

    async function submitForm(e) {
        e.preventDefault();
        const bodyFormData = new FormData();

        bodyFormData.append('email', email);


        const response = await axios.post(`https://saudigermanacademy.com/Aadm25/api/mwforms/subscribtion`, bodyFormData)
            .then(response => {
                // console.log(branchValue);
                // Handle the response
                if (response.data.Ecode === 200) {
                    // setCheckPhoneNum(response.data.Emsg);
                    console.log(response.data);
                    // handleShow();
                    if (response.data.Edata.request_id > 0) {
                        setSubmitMsg('Thank You!')
                        setMessage("Your form has been submitted successfully.")
                    } else {
                        setSubmitMsg('Oppssss!! please Check Your Data ')

                    }

                    handleShow();

                }

            })
            .catch(error => {
                // Handle any errors
                console.error(error);
            });

    }
    return <>
        <div id="wrapper" class="clearfix">
            {/* Start main-content */}
            <div className="main-content-area">
                {/* Section: home */}
                <section
                    id="home"
                    className="bg-lightest fullscreen layer-overlay overlay-dark-9"
                    style={{ backgroundImage: `url('images/bg/bg1.jpg')` }}
                >
                    <div className="display-table text-center">
                        <div className="display-table-cell">
                            <div className="container pt-0 pb-0">
                                <div className="row">
                                    <div className="col-md-10 offset-md-1">
                                        <h1 className="text-white font-weight-100 font-64">
                                            We Are Coming Soon
                                        </h1>
                                        <div
                                            id="basic-coupon-clock"
                                            className="text-center text-white font-size-36 pt-10 pb-10"
                                        />
                                        {/* Final Countdown Timer Script */}
                                    </div>
                                    <div className="col-md-8 offset-md-2">
                                        <form onSubmit={submitForm} className="newsletter-form mt-0 mb-30 maxwidth500">
                                            <label htmlFor="mce-EMAIL" />
                                            <div className="input-group">
                                                <input
                                                    type="email"
                                                    id="mce-EMAIL"
                                                    data-height="45px"
                                                    className="form-control input-lg"
                                                    placeholder="Your Email"
                                                    name="EMAIL"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                                <span className="input-group-btn">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-colored btn-theme-colored1 btn-flat m-0"
                                                        data-height="45px"
                                                    >
                                                        Subscribe
                                                    </button>
                                                </span>
                                            </div>
                                        </form>
                                        <div className="col-sm-12 my-5 text-center">

                                            <Modal   {...props}
                                                size="lg"
                                                style={customStyles}
                                                aria-labelledby="contained-modal-title-vcenter"
                                                centered show={show} onHide={handleClose} className="top-0 ">

                                                <Modal.Header closeButton>
                                                    <img className="" src='/images/cropped-9952-img-32x32.jpg' alt="" />

                                                    <Modal.Title className='text-theme-colored2 fw-bold'>Subscribtion</Modal.Title>
                                                </Modal.Header>

                                                <Modal.Body>
                                                    <div className="team-member text-center">
                                                        <div className="team-description pt-0">
                                                            <h3><Link>{submitMsg}</Link></h3>
                                                            <p className='lead fw-light'>{message}</p>
                                                        </div>



                                                    </div>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <Button className='btn btn-theme-colored2 btn-sm appoint-btn mt-3 mt-sm-0' variant="secondary" onClick={handleClose}>
                                                        Close
                                                    </Button>

                                                </Modal.Footer>

                                            </Modal>
                                        </div>
                                        {/* Mailchimp Subscription Form Validation*/}
                                        <p className="font-14 text-white">
                                            Sorry.... We are improving and fixing problems of our website.
                                            <br />
                                            We will be back very soon....
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
            {/* end main-content */}

            {/* Footer */}
            <footer id="footer" className="footer bg-black-333 text-center pt-20 pb-20">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <p className="mb-0">Copyright ©2025 Saudi German Academy. All Rights Reserved</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>


    </>
}
